var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.data}},_vm._l((_vm.columns),function(col,index){return _c('el-table-column',{key:index,attrs:{"prop":col.prop,"label":col.label}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }